// Package configurations for offers
export const PACKAGES = {
  Basic: {
    name: 'BASIC',
    emoji: '🌱',
    price: '1\'500 – 2\'500',
    targetGroup: 'Ideal für Einzelunternehmer & kleine Betriebe',
    description: 'Perfekt für den Start in die digitale Welt',
    color: 'from-gray-500 to-gray-600',
    features: [
      { icon: '📄', title: 'Anzahl Seiten', text: '3–5 Seiten' },
      { icon: '🎨', title: 'Design', text: 'Modernes Template-Design' },
      { icon: '📱', title: 'Mobile', text: 'Mobile-Optimierung' },
      { icon: '🔍', title: 'SEO Basis', text: 'Grundoptimierung' },
      { icon: '⚙️', title: 'Lokales SEO', text: 'Basis Setup' },
      { icon: '📝', title: 'Content', text: 'Standard-Texte' },
      { icon: '📧', title: 'Formulare', text: 'Kontaktformular' },
      { icon: '🗺️', title: 'Google Maps', text: 'Maps Integration' },
      { icon: '📊', title: 'Google Business', text: 'Basis-Setup' },
      { icon: '📸', title: 'Galerie', text: 'Bis zu 10 Bilder' },
      { icon: '🎯', title: 'Lead-Gen', text: 'Basis CTA' },
      { icon: '📈', title: 'Analytics', text: 'Google Analytics' },
      { icon: '💬', title: 'WhatsApp', text: 'WhatsApp Button' },
      { icon: '🛠️', title: 'Support', text: '1 Monat E-Mail' }
    ]
  },
  Standard: {
    name: 'STANDARD',
    emoji: '⚡',
    price: '3\'500 – 6\'500',
    targetGroup: 'Ideal für etablierte Handwerksbetriebe',
    description: 'Mehr Seiten, besseres SEO, professioneller',
    color: 'from-blue-500 to-blue-600',
    features: [
      { icon: '📄', title: 'Anzahl Seiten', text: '6–10 Seiten' },
      { icon: '🎨', title: 'Design', text: 'Premium individuelles Design' },
      { icon: '📱', title: 'Mobile', text: 'Mobile-First Optimierung' },
      { icon: '🔍', title: 'SEO Basis', text: 'Erweiterte Optimierung' },
      { icon: '⚙️', title: 'Lokales SEO', text: 'Intensive Optimierung' },
      { icon: '📝', title: 'Content', text: 'Professionelle Texte' },
      { icon: '📧', title: 'Formulare', text: 'Kontakt + Offert-Formular' },
      { icon: '🗺️', title: 'Google Maps', text: 'Maps + Bewertungen' },
      { icon: '📊', title: 'Google Business', text: 'Vollständige Optimierung' },
      { icon: '📸', title: 'Galerie', text: 'Bis zu 30 Bilder + Referenzen' },
      { icon: '🎯', title: 'Lead-Gen', text: 'Optimierte CTAs' },
      { icon: '📈', title: 'Analytics', text: 'Analytics + Tracking' },
      { icon: '💬', title: 'WhatsApp', text: 'WhatsApp + Messenger' },
      { icon: '🛠️', title: 'Support', text: '3 Monate Priority Support' }
    ]
  },
  Pro: {
    name: 'PRO',
    emoji: '🚀',
    price: '7\'500 – 12\'000',
    targetGroup: 'Ideal für wachsende Betriebe & Regionalführer',
    description: 'Maximale Sichtbarkeit & Lead-Generierung',
    color: 'from-cyan-600 to-purple-600',
    recommended: true,
    features: [
      { icon: '📄', title: 'Anzahl Seiten', text: '10–20 Seiten unbegrenzt' },
      { icon: '🎨', title: 'Design', text: 'Premium Design + Animationen' },
      { icon: '📱', title: 'Mobile', text: 'Progressive Web App (PWA)' },
      { icon: '🔍', title: 'SEO Basis', text: 'Erweiterte SEO-Strategie' },
      { icon: '⚙️', title: 'Lokales SEO', text: 'Multi-Standorte Optimierung' },
      { icon: '📝', title: 'Content', text: 'Verkaufsstarke Texte + Blog' },
      { icon: '📧', title: 'Formulare', text: 'CRM-Integration' },
      { icon: '🗺️', title: 'Google Maps', text: 'Multi-Location Setup' },
      { icon: '📊', title: 'Google Business', text: 'Volloptimierung + Monitoring' },
      { icon: '📸', title: 'Galerie', text: 'Unbegrenzt + Video-Integration' },
      { icon: '🎯', title: 'Lead-Gen', text: 'A/B Testing + Funnels' },
      { icon: '📈', title: 'Analytics', text: 'Advanced Analytics + Reports' },
      { icon: '💬', title: 'WhatsApp', text: 'WhatsApp Business API' },
      { icon: '🛠️', title: 'Support', text: '6 Monate VIP Support + Wartung' }
    ]
  },
  Premium: {
    name: 'PREMIUM',
    emoji: '👑',
    price: '15\'000 – 25\'000',
    targetGroup: 'Ideal für Marktführer & Grosskunden',
    description: 'Komplettlösung mit laufender Betreuung',
    color: 'from-purple-600 to-pink-600',
    features: [
      { icon: '📄', title: 'Anzahl Seiten', text: 'Unbegrenzt + Kundenportal' },
      { icon: '🎨', title: 'Design', text: 'Exklusiv-Design + 3D + Video' },
      { icon: '📱', title: 'Mobile', text: 'Native App iOS/Android' },
      { icon: '🔍', title: 'SEO Basis', text: 'Full-Service SEO-Betreuung' },
      { icon: '⚙️', title: 'Lokales SEO', text: 'Regionale Dominanz-Strategie' },
      { icon: '📝', title: 'Content', text: 'Premium Content + PR + Social' },
      { icon: '📧', title: 'Formulare', text: 'Vollautomatisierung + AI' },
      { icon: '🗺️', title: 'Google Maps', text: 'Enterprise Multi-Location' },
      { icon: '📊', title: 'Google Business', text: 'Full Management + Ads' },
      { icon: '📸', title: 'Galerie', text: 'Profi-Fotoshootings inklusive' },
      { icon: '🎯', title: 'Lead-Gen', text: 'Conversion-Optimierung + AI' },
      { icon: '📈', title: 'Analytics', text: 'Custom Dashboards + BI' },
      { icon: '💬', title: 'WhatsApp', text: 'WhatsApp + Chatbot AI' },
      { icon: '🛠️', title: 'Support', text: '12 Monate Dedicated Manager' }
    ]
  }
};

export const getPackageDetails = (packageType) => {
  return PACKAGES[packageType] || null;
};

export const getPackageNames = () => {
  return Object.keys(PACKAGES);
};
